"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListLevelPropertiesManipulator = void 0;
var tslib_1 = require("tslib");
var list_level_property_changed_1 = require("../../changes/model/list/list-level-property-changed");
var history_item_state_1 = require("../../history/states/history-item-state");
var history_item_state_object_1 = require("../../history/states/history-item-state-object");
var json_list_enums_1 = require("../../json/enums/json-list-enums");
var list_level_1 = require("../../numbering-lists/list-level");
var base_manipulator_1 = require("../base-manipulator");
var ListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(ListLevelPropertiesManipulator, _super);
    function ListLevelPropertiesManipulator(manipulator) {
        var _this = _super.call(this, manipulator) || this;
        _this.start = new StartListLevelPropertiesManipulator(manipulator);
        _this.format = new FormatListLevelPropertiesManipulator(manipulator);
        _this.alignment = new AlignmentListLevelPropertiesManipulator(manipulator);
        _this.convertPreviousLevelNumberingToDecimal = new ConvertPreviousLevelNumberingToDecimalListLevelPropertiesManipulator(manipulator);
        _this.separator = new SeparatorListLevelPropertiesManipulator(manipulator);
        _this.suppressRestart = new SuppressRestartListLevelPropertiesManipulator(manipulator);
        _this.suppressBulletResize = new SuppressBulletResizeListLevelPropertiesManipulator(manipulator);
        _this.displayFormatString = new DisplayFormatStringListLevelPropertiesManipulator(manipulator);
        _this.relativeRestartLevel = new RelativeRestartLevelListLevelPropertiesManipulator(manipulator);
        _this.templateCode = new TemplateCodeListLevelPropertiesManipulator(manipulator);
        _this.originalLeftIndent = new OriginalLeftIndentListLevelPropertiesManipulator(manipulator);
        _this.legacy = new LegacyListLevelPropertiesManipulator(manipulator);
        _this.legacySpace = new LegacySpaceListLevelPropertiesManipulator(manipulator);
        _this.legacyIndent = new LegacyIndentListLevelPropertiesManipulator(manipulator);
        return _this;
    }
    return ListLevelPropertiesManipulator;
}(base_manipulator_1.BaseManipulator));
exports.ListLevelPropertiesManipulator = ListLevelPropertiesManipulator;
var ListLevelPropertiesManipulatorBase = (function () {
    function ListLevelPropertiesManipulatorBase(dispatcher) {
        this.manipulator = dispatcher;
    }
    ListLevelPropertiesManipulatorBase.prototype.setValue = function (model, isAbstractList, listIndex, listLevelIndex, newValue) {
        var oldState = new history_item_state_1.HistoryItemState();
        var newState = new history_item_state_1.HistoryItemState();
        var numberingList = isAbstractList ? model.abstractNumberingLists[listIndex] : model.numberingLists[listIndex];
        var listLevel = numberingList.levels[listLevelIndex];
        if (listLevel instanceof list_level_1.NumberingListReferenceLevel) {
            var abstractNumberingListIndex = numberingList.abstractNumberingListIndex;
            oldState.register(new history_item_state_object_1.HistoryItemListLevelStateObject(true, abstractNumberingListIndex, listLevelIndex, this.getPropertyValue(listLevel.getListLevelProperties())));
            this.setValueCore(listLevel, newValue);
            newState.register(new history_item_state_object_1.HistoryItemListLevelStateObject(true, abstractNumberingListIndex, listLevelIndex, newValue));
        }
        else {
            oldState.register(new history_item_state_object_1.HistoryItemListLevelStateObject(isAbstractList, listIndex, listLevelIndex, this.getPropertyValue(listLevel.getListLevelProperties())));
            this.setValueCore(listLevel, newValue);
            newState.register(new history_item_state_object_1.HistoryItemListLevelStateObject(isAbstractList, listIndex, listLevelIndex, newValue));
        }
        this.manipulator.notifyModelChanged(new list_level_property_changed_1.ListLevelPropertyChangedModelChange(this.getJSONListLevelProperty(), newState));
        return oldState;
    };
    ListLevelPropertiesManipulatorBase.prototype.restoreValue = function (model, state) {
        var stateObject = state.objects[0];
        var numberingList = stateObject.isAbstractNumberingList ? model.abstractNumberingLists[stateObject.numberingListIndex] : model.numberingLists[stateObject.numberingListIndex];
        var listLevel = numberingList.levels[stateObject.listLevelIndex];
        this.setValueCore(listLevel, stateObject.value);
        this.manipulator.notifyModelChanged(new list_level_property_changed_1.ListLevelPropertyChangedModelChange(this.getJSONListLevelProperty(), state));
    };
    ListLevelPropertiesManipulatorBase.prototype.setValueCore = function (level, newValue) {
        var properties = level.getListLevelProperties().clone();
        this.setPropertyValue(properties, newValue);
        level.setListLevelProperties(properties);
    };
    return ListLevelPropertiesManipulatorBase;
}());
var StartListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(StartListLevelPropertiesManipulator, _super);
    function StartListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StartListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.start = newValue;
    };
    StartListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.start;
    };
    StartListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.Start;
    };
    return StartListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var FormatListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(FormatListLevelPropertiesManipulator, _super);
    function FormatListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormatListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.format = newValue;
    };
    FormatListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.format;
    };
    FormatListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.Format;
    };
    return FormatListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var AlignmentListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(AlignmentListLevelPropertiesManipulator, _super);
    function AlignmentListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlignmentListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.alignment = newValue;
    };
    AlignmentListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.alignment;
    };
    AlignmentListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.Alignment;
    };
    return AlignmentListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var ConvertPreviousLevelNumberingToDecimalListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(ConvertPreviousLevelNumberingToDecimalListLevelPropertiesManipulator, _super);
    function ConvertPreviousLevelNumberingToDecimalListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConvertPreviousLevelNumberingToDecimalListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.convertPreviousLevelNumberingToDecimal = newValue;
    };
    ConvertPreviousLevelNumberingToDecimalListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.convertPreviousLevelNumberingToDecimal;
    };
    ConvertPreviousLevelNumberingToDecimalListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.ConvertPreviousLevelNumberingToDecimal;
    };
    return ConvertPreviousLevelNumberingToDecimalListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var SeparatorListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(SeparatorListLevelPropertiesManipulator, _super);
    function SeparatorListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SeparatorListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.separator = newValue;
    };
    SeparatorListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.separator;
    };
    SeparatorListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.Separator;
    };
    return SeparatorListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var SuppressRestartListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(SuppressRestartListLevelPropertiesManipulator, _super);
    function SuppressRestartListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuppressRestartListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.suppressRestart = newValue;
    };
    SuppressRestartListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.suppressRestart;
    };
    SuppressRestartListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.SuppressRestart;
    };
    return SuppressRestartListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var SuppressBulletResizeListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(SuppressBulletResizeListLevelPropertiesManipulator, _super);
    function SuppressBulletResizeListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuppressBulletResizeListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.suppressBulletResize = newValue;
    };
    SuppressBulletResizeListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.suppressBulletResize;
    };
    SuppressBulletResizeListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.SuppressBulletResize;
    };
    return SuppressBulletResizeListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var DisplayFormatStringListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(DisplayFormatStringListLevelPropertiesManipulator, _super);
    function DisplayFormatStringListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DisplayFormatStringListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.displayFormatString = newValue;
    };
    DisplayFormatStringListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.displayFormatString;
    };
    DisplayFormatStringListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.DisplayFormatString;
    };
    return DisplayFormatStringListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var RelativeRestartLevelListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(RelativeRestartLevelListLevelPropertiesManipulator, _super);
    function RelativeRestartLevelListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RelativeRestartLevelListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.relativeRestartLevel = newValue;
    };
    RelativeRestartLevelListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.relativeRestartLevel;
    };
    RelativeRestartLevelListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.RelativeRestartLevel;
    };
    return RelativeRestartLevelListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var TemplateCodeListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(TemplateCodeListLevelPropertiesManipulator, _super);
    function TemplateCodeListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TemplateCodeListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.templateCode = newValue;
    };
    TemplateCodeListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.templateCode;
    };
    TemplateCodeListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.TemplateCode;
    };
    return TemplateCodeListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var OriginalLeftIndentListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(OriginalLeftIndentListLevelPropertiesManipulator, _super);
    function OriginalLeftIndentListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OriginalLeftIndentListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.originalLeftIndent = newValue;
    };
    OriginalLeftIndentListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.originalLeftIndent;
    };
    OriginalLeftIndentListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.OriginalLeftIndent;
    };
    return OriginalLeftIndentListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var LegacyListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(LegacyListLevelPropertiesManipulator, _super);
    function LegacyListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegacyListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.legacy = newValue;
    };
    LegacyListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.legacy;
    };
    LegacyListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.Legacy;
    };
    return LegacyListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var LegacySpaceListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(LegacySpaceListLevelPropertiesManipulator, _super);
    function LegacySpaceListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegacySpaceListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.legacySpace = newValue;
    };
    LegacySpaceListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.legacySpace;
    };
    LegacySpaceListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.LegacySpace;
    };
    return LegacySpaceListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
var LegacyIndentListLevelPropertiesManipulator = (function (_super) {
    tslib_1.__extends(LegacyIndentListLevelPropertiesManipulator, _super);
    function LegacyIndentListLevelPropertiesManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegacyIndentListLevelPropertiesManipulator.prototype.setPropertyValue = function (properties, newValue) {
        properties.legacyIndent = newValue;
    };
    LegacyIndentListLevelPropertiesManipulator.prototype.getPropertyValue = function (properties) {
        return properties.legacyIndent;
    };
    LegacyIndentListLevelPropertiesManipulator.prototype.getJSONListLevelProperty = function () {
        return json_list_enums_1.JSONListLevelProperty.LegacyIndent;
    };
    return LegacyIndentListLevelPropertiesManipulator;
}(ListLevelPropertiesManipulatorBase));
